import axiosClient from './axiosClient';

export const addNoteIntoCRM = (idQuote:any,data: any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/quotes/api/quote/${idQuote}/notes`
   return axiosClient.post(url, data)
};
